import React, { useRef, useState } from 'react';
import { Document, IbmWatsonDiscovery, LicenseThirdPartyDraft, Upload, Edit } from '@carbon/icons-react';
import { Breadcrumb, BreadcrumbItem, Stack, Button, RadioButtonGroup, RadioButton, TextInput, SelectItem, Select, ComboBox, Modal, FileUploader, InlineNotification } from '@carbon/react';
import { CardComponent } from '../../../components/Layouts/Card.styles';
import Card from '../../../components/Layouts/Card';
import Typography from '../../../components/Basics/Typography';
import InformationContainer from '../../../components/Basics/Information.container';
import { spacing05 } from "@carbon/themes";
import SearchTable from '../../../components/Basics/SearchTable.container';
import { Separator } from '../../Dashboard/Dashboard.styles';

/**
 * The Map's Page.
 */
const OrderContainer = () => {
    const button = useRef();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewOrderModalOpen, setIsNewOrderModalOpen] = useState(false);
    const [fileUploaded, setFileUploaded] = useState(null);
    const items = [
        { id: 'equipo_1', label: 'Equipo 1' },
        { id: 'equipo_2', label: 'Equipo 2' },
        { id: 'equipo_3', label: 'Equipo 3' },
        { id: 'equipo_4', label: 'Equipo 4' },
        { id: 'equipo_5', label: 'Equipo 5' },
    ];

    const rows = [
        {
            id: 'a',
            ot: '324267',
            equipo: 'Equipo 1',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'incompleta',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'b',
            ot: '324268',
            equipo: 'Equipo 2',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'incompleta',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'c',
            ot: '324269',
            equipo: 'Equipo 3',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'incompleta',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'd',
            ot: '324270',
            equipo: 'Equipo 4',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'incompleta',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'e',
            ot: '324271',
            equipo: 'Equipo 5',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'incompleta',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'f',
            ot: '324272',
            equipo: 'Equipo 6',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'incompleta',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
    ];

    const rows_2 = [
        {
            id: 'g',
            ot: '324273',
            equipo: 'Equipo 1',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'h',
            ot: '324274',
            equipo: 'Equipo 2',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'i',
            ot: '324275',
            equipo: 'Equipo 3',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'j',
            ot: '324276',
            equipo: 'Equipo 4',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'k',
            ot: '324277',
            equipo: 'Equipo 5',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
        {
            id: 'l',
            ot: '324278',
            equipo: 'Equipo 6',
            tipo: 'Lavado',
            servicio: 'Aljibes',
            ubicacion: 'Mina Norte',
            conductor: 'Juanito Perez',
            estado: 'completas',
            horo_inicio: '08:00',
            horo_termino: '14:00',
            vol_inicial: '12',
            vol_final: '5',
            flu_inicial: '12',
            flu_final: '5',
        },
    ];

    const headers = [
        { key: 'ot', header: 'ID' },
        { key: 'equipo', header: 'Equipo' },
        { key: 'tipo', header: 'Tipo de OT' },
        { key: 'servicio', header: 'Servicio' },
        { key: 'ubicacion', header: 'Ubicación' },
        { key: 'conductor', header: 'Conductor Responsable' },
        { key: 'estado', header: 'Estado de la OT' },
        { key: 'horo_inicio', header: 'Horómetro Inicial' },
        { key: 'horo_termino', header: 'Horómetro Final' },
        { key: 'vol_inicial', header: 'Vol Inicial' },
        { key: 'vol_final', header: 'Vol Final' },
        { key: 'flu_inicial', header: 'Flujo Inicial' },
        { key: 'flu_final', header: 'Flujo Final' }
    ];

    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    // Función para manejar la edición de una orden
    const handleEditOrder = (rowId) => {
        // Buscar la orden en ambas tablas
        const orderToEdit = [...rows, ...rows_2].find(row => row.id === rowId);
        if (orderToEdit) {
            setSelectedOrder(orderToEdit);
            setIsEditMode(true);
            setIsNewOrderModalOpen(true);
        }
    };

    // Modificar el componente SearchTable para incluir acciones
    const renderCustomTable = (rows, headers, title) => {
        return (
            <SearchTable 
                rows={rows} 
                headers={headers} 
                title={title}
                onEditRow={handleEditOrder}  // Pasar la función de edición
            />
        );
    };

    // Función para manejar cambios en los campos del formulario
    const handleOrderChange = (field, value) => {
        if (selectedOrder) {
            setSelectedOrder({
                ...selectedOrder,
                [field]: value
            });
        }
    };

    // Función para guardar los cambios
    const saveOrderChanges = () => {
        // Aquí implementarías la lógica para guardar los cambios en tu estado de filas
        // Por ejemplo, actualizar la fila en el array original
        const updatedRows = rows.map(row => 
            row.id === selectedOrder.id ? selectedOrder : row
        );
        const updatedRows2 = rows_2.map(row => 
            row.id === selectedOrder.id ? selectedOrder : row
        );
        
        // Aquí podrías actualizar el estado de tus filas
        // setRows(updatedRows);
        // setRows2(updatedRows2);
        
        setIsNewOrderModalOpen(false);
        setIsEditMode(false);
        setSelectedOrder(null);
        alert("Orden actualizada");
    };

    return (
        <Stack gap={3}>
            <CardComponent width="100%">
                <Card $justifyContent='flex-start' background="transparent" flexDirection="column" alignItems='flex-start'>
                    <p style={{ color: '#8D8D8D' }}>Herramientas asociadas al módulo</p>
                    <Separator />
                    <Stack orientation="horizontal">
                        <Button
                            renderIcon={Document}
                            kind="secondary"
                            size="sm"
                            style={{ backgroundColor: '#6C757D', color: '#FFF', width: 'fit-content', whiteSpace: 'nowrap' }}
                            onClick={() => setIsModalOpen(true)}
                        >
                            Cargar Ordenes de trabajo
                        </Button>
                        <Button
                            renderIcon={Document}
                            kind="secondary"
                            size="sm"
                            style={{ backgroundColor: '#6C757D', color: '#FFF', width: 'fit-content', whiteSpace: 'nowrap' }}
                            onClick={() => setIsNewOrderModalOpen(true)}
                        >
                            Crear Orden de trabajo No programada
                        </Button>
                    </Stack>
                </Card>

                <Card $justifyContent='flex-start' background="transparent" flexDirection="column" alignItems='flex-start'>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        <div style={{
                            width: '100%',
                            padding: 'spacing05',
                            display: 'flex',
                            alignItems: 'flex-end',
                            gap: '0.5rem'
                        }}
                        >
                            <ComboBox
                                id="equipos"
                                items={items}
                                itemToString={(item) => (item ? item.label : '')}
                                placeholder="Seleccionar equipo"
                                titleText="Equipo"
                                onChange={() => {}}
                            />
                            <Button size='md' kind="primary" renderIcon={IbmWatsonDiscovery}>
                                Buscar datos
                            </Button>
                        </div>
                        <p>Tabla - Ordenes de trabajo no completadas - Tabla de Datos</p>
                        <p style={{ color: '#8D8D8D', fontSize: '0.8rem' }}>Filtros</p>
                    </div>
                        <Separator />
                        <SearchTable rows={rows} headers={headers} onEditRow={handleEditOrder} title='Ordenes de trabajo - Sin Completar' />
                        <SearchTable rows={rows_2} headers={headers} onEditRow={handleEditOrder} title='Ordenes de trabajo - Completadas' />
                </Card>
            </CardComponent>
            <Modal
                open={isModalOpen}
                modalHeading="Cargar Ordenes de Trabajo para Hoy"
                primaryButtonText="Cargar OTs"
                secondaryButtonText="Cancelar"
                primaryButtonDisabled={!fileUploaded}
                onRequestClose={() => setIsModalOpen(false)}
                onRequestSubmit={() => {
                    setIsModalOpen(false);
                    alert("Carga iniciada");
                }}
            >
                <p>Subir el archivo de ordenes de trabajo para hoy.</p>

                <FileUploader
                    labelDescription=""
                    buttonLabel="Seleccionar archivo"
                    filenameStatus="edit"
                    accept={[".csv", ".xlsx"]}
                    iconDescription="Borrar archivo"
                    onChange={(event) => setFileUploaded(event.target.files[0])}
                />

                {fileUploaded && (
                    <InlineNotification
                        kind="info"
                        iconDescription="Información"
                        title="Revise la fecha del documento antes de confirmar el formulario."
                        style={{ backgroundColor: 'transparent' }}
                        lowContrast
                    />
                )}
            </Modal>
            <Modal
                open={isNewOrderModalOpen}
                modalHeading={isEditMode ? "Editar orden de trabajo" : "Crear nueva orden de trabajo"}
                primaryButtonText={isEditMode ? "Guardar Cambios" : "Crear Orden"}
                secondaryButtonText="Cancelar"
                onRequestClose={() => {
                    setIsNewOrderModalOpen(false);
                    setIsEditMode(false);
                    setSelectedOrder(null);
                }}
                onRequestSubmit={() => {
                    if (isEditMode) {
                        saveOrderChanges();
                    } else {
                        setIsNewOrderModalOpen(false);
                        alert("Orden creada");
                    }
                }}
                size="sm"
            >
                <p>
                    {isEditMode 
                        ? "Edite los campos de la orden de trabajo seleccionada."
                        : "En este formulario puede ingresar órdenes de trabajo de forma individual, para que estos también puedan ser detectados en el mapa."}
                    <br />
                    Los campos de horómetro, volumen y flujo solamente pueden ser modificados en la tabla de OT completadas.
                </p>

                <div style={{ display: 'flex', gap: '2rem', width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '50%' }}>
                        <TextInput
                            id="id_ot"
                            labelText="ID OT"
                            value={selectedOrder ? selectedOrder.ot : "1000"}
                            readOnly
                        />

                        <Select 
                            id="tipo_ot" 
                            labelText="Tipo de OT"
                            value={selectedOrder ? selectedOrder.tipo : ""}
                            onChange={(e) => handleOrderChange('tipo', e.target.value)}
                        >
                            <SelectItem text="Seleccione el tipo de OT" value="" />
                            <SelectItem text="Lavado" value="Lavado" />
                            {/* Agregar más opciones según sea necesario */}
                        </Select>

                        <Select 
                            id="equipo" 
                            labelText="Equipo"
                            value={selectedOrder ? selectedOrder.equipo : ""}
                            onChange={(e) => handleOrderChange('equipo', e.target.value)}
                        >
                            <SelectItem text="Seleccione un equipo" value="" />
                            {items.map(item => (
                                <SelectItem key={item.id} text={item.label} value={item.label} />
                            ))}
                        </Select>

                        <TextInput 
                            id="servicio" 
                            labelText="Servicio" 
                            value={selectedOrder ? selectedOrder.servicio : ""}
                            onChange={(e) => handleOrderChange('servicio', e.target.value)}
                        />

                        <Select 
                            id="ubicacion" 
                            labelText="Ubicación"
                            value={selectedOrder ? selectedOrder.ubicacion : ""}
                            onChange={(e) => handleOrderChange('ubicacion', e.target.value)}
                        >
                            <SelectItem text="Mina Norte" value="Mina Norte" />
                            <SelectItem text="Mina Sur" value="Mina Sur" />
                            {/* Agregar más opciones según sea necesario */}
                        </Select>

                        <TextInput 
                            id="conductor" 
                            labelText="Conductor Responsable" 
                            value={selectedOrder ? selectedOrder.conductor : ""}
                            onChange={(e) => handleOrderChange('conductor', e.target.value)}
                        />

                        <TextInput
                            id="estado_ot"
                            labelText="Estado de la OT"
                            value={selectedOrder ? selectedOrder.estado : ""}
                            onChange={(e) => handleOrderChange('estado', e.target.value)}
                        />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '50%' }}>
                        <TextInput 
                            id="horo_inicial" 
                            labelText="Horómetro Inicial" 
                            value={selectedOrder ? selectedOrder.horo_inicio : ""}
                            onChange={(e) => handleOrderChange('horo_inicio', e.target.value)}
                        />
                        <TextInput 
                            id="horo_final" 
                            labelText="Horómetro Final" 
                            value={selectedOrder ? selectedOrder.horo_termino : ""}
                            onChange={(e) => handleOrderChange('horo_termino', e.target.value)}
                        />
                        <TextInput 
                            id="vol_inicial" 
                            labelText="Vol. Inicial" 
                            value={selectedOrder ? selectedOrder.vol_inicial : ""}
                            onChange={(e) => handleOrderChange('vol_inicial', e.target.value)}
                        />
                        <TextInput 
                            id="vol_final" 
                            labelText="Vol. Final" 
                            value={selectedOrder ? selectedOrder.vol_final : ""}
                            onChange={(e) => handleOrderChange('vol_final', e.target.value)}
                        />
                        <TextInput 
                            id="flujo_inicial" 
                            labelText="Flujo Inicial" 
                            value={selectedOrder ? selectedOrder.flu_inicial : ""}
                            onChange={(e) => handleOrderChange('flu_inicial', e.target.value)}
                        />
                        <TextInput 
                            id="flu_final" 
                            labelText="Flujo Final" 
                            value={selectedOrder ? selectedOrder.flu_final : ""}
                            onChange={(e) => handleOrderChange('flu_final', e.target.value)}
                        />
                    </div>
                </div>
            </Modal>
        </Stack>
    );
};

export default OrderContainer;
